export const TAB_KEYS = {
  COMMERCIAL: 'commercial',
  CUSTOMER: 'customer',
  PRODUCTIVITY: 'productivity',
  LOGISTIC: 'logistic',
}
